import {
  initialState,
  Actions,
  State,
  DELETE_MODULE,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_ERROR,
  RESET_DELETE_MODULE
} from "../../types/module/delete-module";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_MODULE:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_MODULE_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_MODULE_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_MODULE:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
